import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
const META_PIXEL_ID = '1237593141556086';
function initMetaPixel() {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.fbq) return;
  // Inline the official Meta Pixel snippet via a script tag (verbatim).
  const inlineScript = document.createElement('script');
  inlineScript.text = `
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${META_PIXEL_ID}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(inlineScript);
  // <noscript> fallback pixel
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=' + META_PIXEL_ID + '&ev=PageView&noscript=1';
  document.body.appendChild(img);
}
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { DegreeListingPage } from './pages/DegreeListingPage';
import { ExpandedFormPage } from './pages/ExpandedFormPage';
import { ResultsPage } from './pages/ResultsPage';
import { UniversityPage } from './pages/UniversityPage';
import { UMALandingPage } from './pages/UMALandingPage';
import { GTCLandingPage } from './pages/GTCLandingPage';
import { UAGCLandingPage } from './pages/UAGCLandingPage';
import { CCULandingPage } from './pages/CCULandingPage';
import { HCULandingPage } from './pages/HCULandingPage';
import { CollegesPage } from './pages/CollegesPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { RequestInformationPage } from './pages/RequestInformationPage';
import { RequestInformationForm } from './pages/RequestInformationForm';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsAndConditionsPage } from './pages/TermsAndConditionsPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { DoNotSellMyInfoPage } from './pages/DoNotSellMyInfoPage';
import { GuidePage } from './pages/GuidePage';
import { FindDegreesPage } from './pages/FindDegreesPage';
function AppContent() {
  const location = useLocation();
  // Hide global header on individual college pages (e.g. /colleges/global-tech-college or /colleges/global-tech-college/program)
  const isCollegeDetailPage = /^\/colleges\/[^/]+/.test(location.pathname) && location.pathname !== '/colleges' || /^\/universities(\/[^/]+)?$/.test(location.pathname);
  const isThankYouPage = location.pathname === '/thank-you';
  const isRequestInfoForm = location.pathname === '/request-information/form';
  const isFindDegreesPage = /^\/find-degrees\//i.test(location.pathname);
  const hideChrome = isCollegeDetailPage || isThankYouPage || isRequestInfoForm || isFindDegreesPage;
  // Initialize Meta Pixel once on mount
  useEffect(() => {
    initMetaPixel();
  }, []);
  // Track PageView on every route change
  useEffect(() => {
    const w = window as any;
    if (typeof window !== 'undefined' && w.fbq) {
      w.fbq('track', 'PageView');
    }
  }, [location.pathname]);
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0" data-mp="1w3vl1xr7h526">
      {!hideChrome && <Header data-id="element-1" data-mp="1i3ksmqa8ziew" />}
      <Routes data-id="element-2" data-mp="1i4401d29uoeo">
        <Route path="/" element={<HomePage data-id="element-4" data-mp="1i319j68v2nza" />} data-id="element-3" data-mp="1i4ch7h5fgfvo" />
        <Route path="/form" element={<ExpandedFormPage data-id="element-6" data-mp="1m4wdyjm39hha" />} data-id="element-5" data-mp="1i5nldi2sbpnb" />
        <Route path="/degree/:areaStudy/:program" element={<HomePage data-id="element-8" data-mp="6ofcokl3vndc" />} data-id="element-7" data-mp="1m3uze55v6cut" />
        <Route path="/degrees/:category" element={<DegreeListingPage data-id="element-10" data-mp="6mum161wwokr" />} data-id="element-9" data-mp="6nw6g14tinf5" />
        <Route path="/colleges" element={<CollegesPage data-id="element-12" data-mp="aq99ghs6k788" />} data-id="element-11" data-mp="aq0wyqzyz3xk" />
        <Route path="/colleges/ultimate-medical-academy" element={<UMALandingPage data-id="element-14" data-mp="qy73h18vn18k" />} data-id="element-13" data-mp="arkd8hlmlezc" />
        <Route path="/colleges/global-tech-college" element={<GTCLandingPage data-id="element-16" data-mp="m5ng5cke0rqk" />} data-id="element-15" data-mp="qz8fp91mptrv" />
        <Route path="/colleges/university-of-arizona-global-campus" element={<UAGCLandingPage data-id="element-18" data-mp="h59hum8l8w5q" />} data-id="element-17" data-mp="m4m1ky45xn43" />
        <Route path="/colleges/colorado-christian-university" element={<CCULandingPage data-id="element-20" data-mp="19vztj2yejgoj" />} data-id="element-19" data-mp="c8rftu4n7bx3" />
        <Route path="/colleges/houston-christian-university" element={<HCULandingPage data-id="element-22" data-mp="14wez95u6fwi5" />} data-id="element-21" data-mp="19uyl768rt8ai" />
        <Route path="/universities" element={<HCULandingPage data-id="element-24" data-mp="zxtviwfpuuoy" />} data-id="element-23" data-mp="14xg7l2jt64w6" />
        <Route path="/universities/houston-christian-university" element={<HCULandingPage data-id="element-26" data-mp="vwrtk7uf04ja" />} data-id="element-25" data-mp="zx29ac80e9bc" />
        <Route path="/colleges/:universitySlug" element={<UniversityPage data-id="element-28" data-mp="3ko2osg6v2mqx" />} data-id="element-27" data-mp="vvgswgw9ncwe" />
        <Route path="/colleges/:universitySlug/:programSlug" element={<UniversityPage data-id="element-30" data-mp="3gly0zy33gkc7" />} data-id="element-29" data-mp="3kob2ubepzy3p" />
        <Route path="/results" element={<ResultsPage data-id="element-32" data-mp="3gotzpomrnd1p" />} data-id="element-31" data-mp="3gkwcaqt5nzc0" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-34" data-mp="1w5q4cfjjm5ah" />} data-id="element-33" data-mp="1w4ylm5b1o21m" />
        <Route path="/request-information" element={<RequestInformationPage data-id="element-36" data-mp="2071xuw5jfany" />} data-id="element-35" data-mp="1w2c3jbqj2455" />
        <Route path="/request-information/form" element={<RequestInformationForm data-id="element-38" data-mp="253k1fsp4t2yp" />} data-id="element-37" data-mp="203ntxjh86tee" />
        <Route path="/guide/:slug" element={<GuidePage data-id="element-40" data-mp="29wv7vsq17hq3" />} data-id="element-39" data-mp="29vjud16savls" />
        <Route path="/find-degrees/:template" element={<FindDegreesPage data-id="element-42" data-mp="2ev6gk04lbm6q" />} data-id="element-41" data-mp="29x4oipp6scj4" />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-44" data-mp="2ex97qnhhbld1" />} data-id="element-43" data-mp="2eu4vd2tv1jba" />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage data-id="element-46" data-mp="2jw3x689yc864" />} data-id="element-45" data-mp="2jthscgeg46rl" />
        <Route path="/cookie-policy" element={<CookiePolicyPage data-id="element-48" data-mp="2nwe3xn5kj2m1" />} data-id="element-47" data-mp="2nvcufn47ao6f" />
        <Route path="/do-not-sell-my-info" element={<DoNotSellMyInfoPage data-id="element-50" data-mp="2stecc4pw4hgb" />} data-id="element-49" data-mp="2supcluk4n72o" />
        <Route path="*" element={<HomePage data-id="element-52" data-mp="thtnxns6zv8z" />} data-id="element-51" data-mp="2sslb1j9pak5k" />
      </Routes>
      {!hideChrome && <Footer data-id="element-53" data-mp="tj4t9s1adb27" />}
    </div>;
}
export function App() {
  return <Router data-id="element-54" data-mp="yfv8ye96i4n3">
      <AppContent data-id="element-55" data-mp="yhg1xzfuhfiu" />
    </Router>;
}